import { MediaCardProps } from "../components/MediaCard/MediaCard";

export const mediaCards: MediaCardProps[] = [
  {
    id: "se01-showroom-entrance",
    imageUrl: "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    imageAlt: "Showroom entrance with a living room display",
    images: [
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
    ],
    badgeLabel: "Launch 4",
    title: "SE01: Showroom entrance — TERRSJÖ/TONSTAD",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    location: "Showroom entrance",
    status: "Published",
  },
  {
    id: "l00-living-room",
    imageUrl: "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    imageAlt: "Living room display with storage furniture",
    images: [
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "L00: Living room — SALTMYRAN/KALLAX",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    location: "Living room",
    status: "Unpublished",
  },
  {
    id: "b05-bedroom",
    imageUrl: "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    imageAlt: "Bedroom display with RÅDMANSÖ furniture",
    images: [
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
      "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "B05: Bedroom — RÅDMANSÖ",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    location: "Bedroom",
    status: "Published",
  },
  {
    id: "kv00-kitchen",
    imageUrl: "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    imageAlt: "Kitchen display with ASPUDDEN furniture",
    images: [
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "KV00: Kitchen — ASPUDDEN",
    fiscalYear: "FY26",
    mediaType: "Vignette",
    location: "Kitchen",
    status: "Published",
  },
  {
    id: "mabarsskar-staircase-entrance",
    imageUrl:
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    imageAlt: "Staircase entrance display with MÅBÄRSSKÄR products",
    images: [
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "Staircase entrance — MÅBÄRSSKÄR",
    fiscalYear: "FY26",
    mediaType: "Statement media",
    location: "Staircase entrance",
    status: "Published",
  },
  {
    id: "d01-dining-room",
    imageUrl: "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    imageAlt: "Dining room display with neutral wood and textile styling",
    images: [
      "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "D01: Dining room — TOSTERÖD",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    location: "Dining room",
    status: "Published",
  },
  {
    id: "l12-storage-wall",
    imageUrl: "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    imageAlt: "Storage wall with acoustic and shelving styling",
    images: [
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "L12: Storage wall — BILLY/HEMNES",
    fiscalYear: "FY26",
    mediaType: "Vignette",
    location: "Storage wall",
    status: "Unpublished",
  },
  {
    id: "b12-bedroom",
    imageUrl: "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    imageAlt: "Bedroom styling with layered textiles and lighting",
    images: [
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "B12: Bedroom — HEMNES",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    location: "Bedroom",
    status: "Published",
  },
  {
    id: "kv07-kitchen",
    imageUrl: "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    imageAlt: "Kitchen island scenario with countertop accessories",
    images: [
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
      "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "KV07: Kitchen — KNOXHULT",
    fiscalYear: "FY26",
    mediaType: "Statement media",
    location: "Kitchen",
    status: "Published",
  },
  {
    id: "stockholm-voxla-entryway",
    imageUrl:
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    imageAlt: "Entryway with storage and decor accessory styling",
    images: [
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "Entryway — STOCKHOLM/VOXLA",
    fiscalYear: "FY26",
    mediaType: "Room setting",
    location: "Entryway",
    status: "Published",
  },
];

export const mediaTypes = Array.from(
  new Set(mediaCards.map((card) => card.mediaType))
);

export const locations = Array.from(
  new Set(
    mediaCards
      .map((card) => card.location)
      .filter((location): location is string => Boolean(location))
  )
);
